import clsx from 'clsx';
import React from 'react';
import buttons from '../../css/buttons.module.scss';
import styles from '../../css/modal.module.scss';
import EmailSupportLink from '../email-support-link';
import ExternalTextLink from '../external-text-link';
import { Modal } from './portal';

type ModalProps = {
  isOpen: boolean;
};

const WaitingListModal = React.memo(({ isOpen }: ModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen}>
      <div className={clsx(styles.modalContent, styles.waitlistModal)}>
        <h3 className={styles.modalTitle}>Join the Waitlist</h3>
        <p className={styles.p}>
          The Pivot Flex pilot is at capacity. Please join our waitlist so we
          can send you an invite when more seats are available!
        </p>
        <ExternalTextLink
          label="Join Waitlist"
          href="https://www.surveymonkey.com/r/K8DC3KB"
          className={buttons.submitBtn}
        />
        <hr className={styles.hr} />
        <small className={styles.small}>
          If you have any questions, please contact Pivot support at:{' '}
          <EmailSupportLink className={styles.emailLink} />
        </small>
      </div>
    </Modal>
  );
});

export default WaitingListModal;
